
export default {
    props: ["device"],
    data() {
        return {};
    },
    methods: {
        openDialog(n: string): void {
            //funkcja wysyłająca do komponentu "matki", id dialogu, który musi zostać wyświetlony
            (this as any).$emit("deviceId", n);
        },
    },
};
